const a0_0x5079 = [
    'w4hSeVzDoiHCnhDCk1w0UMKWT8K/ZQvDmELCisKPOsOEGll8esKSA3fCvsO0RMK1LcKKw4PCjcOGQnXCgAJNw73CpsKtaMOWw73CsSQpOTUjwqnDh8K9woggZMKRD2MZwrkHwqLDusO5w5k=',
    'bcOew48Nw7dGOcK8e3o8fh/DkgjCvQcpwqXCk1bCpMO0d8K/w70cwpNhwrLDvMO6M1Uyw5EvwrzCr8OwwrnDqMOVQ8OoZ8K9wqZQEcKPQm/Djk05wrfCv3d6w4fDnsK2dxoiJi7ClMKLKH4=',
    'Oy0Dw7gocS7Cm0DCrsKZf8K6w6DCtsO5w7dmRsK4wq5HSCVOw6sWKsKyCnZFSgfCtBRyBSPDmCXCnBXCk8KTI8KgVlbDg8OAOh8xfMK6YsKRP0cewo3CuMOoXcKDw55rwpXCsE3CqMO0wp/DmgjDhsKow6TCkG/Cu8OcwpRBfcOFLcKeTEnCpArCkWwdw6/DiTbCi1gPwozCu8Knw4oTCA==',
    'J8Kww4DCvMKtEVNDw4wCw5DCgcKTLB5aFsK/w75kw6U5w48GwrhFPzPDmsOOKsKhwoPCq8KYfyEWIsKcwqxZwrYwwpjCgMOHw7LDlEw+w5TDrXrCjcK2Z8OOw5RCwrfDoAHCgMOSwrQ0wppKwpvDmsOt',
    'w6BDw6zCkQ==',
    'w5ICHARkwqjCsMOvasKGw43Diw3CosOnwpkqw7rDosOTesO1KBDCmAwOwoDCsmV/w6gbwqhvTcOVw43DqX4rbQjCv8OJdwTCnx1xw6bCosOvw7FCwpI3eMKEHAdqw7kfwqPChmTDhD7Cr3zCssO3w4rCi8Kvw5o1E8KoQMOcD8K3wpnDhTrDq17DpwDCilnDlHnDsMKAOA3CglHCuMOqwqJbacOXwpPDr09zGwJJwprCg1wIJDYaw5V2EhDClkrCusKNw6PCkxZPccOvw5VFwpzCgQhRw5NMw7khwol7JSzClMOpOg==',
    'XMO+wpHCoBnCqGPDmcOdwpPDrMKwLcK5Xm4QJ8OvTGnDiMOoFsOndzF2w49hwrPDpcKSwp9mITPCiAw=',
    'w6cmw6fDk0DCucOLO3PDiD5VFgzCp8OKfcO1w41Yw4F7wrzDrMKkw5/Djm7Cu8KCYXvCg1TDqgQ=',
    'wqFLaX/DlsKiecKcbsKNcsOyw55kwpw8eUQ9w4PCoXHCqiTDjR1EwopFw5TDpEDDhzjCjMKCw6/CvQc=',
    'w5DDl8Kyaw==',
    'NT/CsWRvwoNC',
    'wqF3ZXAew7zCs8KTP8OQwp7Dhg==',
    'a1jCtTgOYVtfKsKoFHPDvMOmaydSw63Ci8OJXcO4wr7Ck8K8UcKLw7pPw6DDnG5CDsOjw5rDoMOXw4A=',
    'wp/CqsOvw5ZkBcKTwp0hw7Etw7kYag==',
    'woHDqcKPw6zDm1Bke2IuLBPDrMODw51C',
    'w5TCm8OIwrJULMO7woDDosKLWDLCtcKbWBZld8KYXsOuwoHCoAvCimkTwo53wrbDicOAYU/DpBXDvg3DvA==',
    'woHDnMOrwpk=',
    'OcOAw5rChw==',
    'wodcF0LDhW9zw6gjw5DCu8Kfw7NJwonCtFZuwqJXwpc6w71OYsKdBcOwYMKawp/DiFLDhivDs0vDi8OzXT8aEzzCiMO3TcKOb2hVQcOSAwk4w5xtN8OzwpDCvcOGwpthbMKDw4LDgwbDocKSElTCu8Ojw7vDg8OLZiIGEcOww5JOw5fDhCkzOsKFCcOYBycmZwfCoMKeOsKNHV4cCDA=',
    'R28Zw6kIFMO1w7jCu8OXX8K4UW89wotnOVhPwoMRwr4X',
    'wqFfAcK3UsKxGMOfwpTDpU7Dv8O9wqjDkizCn8OuBzLDjcO9CmxmEGrDojHDhMKoL8Oaw5dWXlkPw5Qsw7nCvw==',
    'bSXDnRtywrXDgMOMCXo1Hg==',
    'w6MoAjFOwr/Ds8O0WsKGwp/CgXXChMKSw7R8w6HDqcOKa8O8CE3CjAsJwpvChm4awodiw49TSMODw7TCvWAgDQ=='
];
(function (_0x181b36, _0x5079ec) {
    const _0x5598f0 = function (_0x1267db) {
        while (--_0x1267db) {
            _0x181b36['push'](_0x181b36['shift']());
        }
    };
    _0x5598f0(++_0x5079ec);
}(a0_0x5079, 0xc9));
const a0_0x5598 = function (_0x181b36, _0x5079ec) {
    _0x181b36 = _0x181b36 - 0x0;
    let _0x5598f0 = a0_0x5079[_0x181b36];
    if (a0_0x5598['TvgkYg'] === undefined) {
        (function () {
            let _0x4d1d62;
            try {
                const _0x454f9a = Function('return\x20(function()\x20' + '{}.constructor(\x22return\x20this\x22)(\x20)' + ');');
                _0x4d1d62 = _0x454f9a();
            } catch (_0xca4ec5) {
                _0x4d1d62 = window;
            }
            const _0x19d3a1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
            _0x4d1d62['atob'] || (_0x4d1d62['atob'] = function (_0x472640) {
                const _0x18e029 = String(_0x472640)['replace'](/=+$/, '');
                let _0x4c4bac = '';
                for (let _0x458a41 = 0x0, _0x1aa5be, _0x1ebd53, _0x30c72f = 0x0; _0x1ebd53 = _0x18e029['charAt'](_0x30c72f++); ~_0x1ebd53 && (_0x1aa5be = _0x458a41 % 0x4 ? _0x1aa5be * 0x40 + _0x1ebd53 : _0x1ebd53, _0x458a41++ % 0x4) ? _0x4c4bac += String['fromCharCode'](0xff & _0x1aa5be >> (-0x2 * _0x458a41 & 0x6)) : 0x0) {
                    _0x1ebd53 = _0x19d3a1['indexOf'](_0x1ebd53);
                }
                return _0x4c4bac;
            });
        }());
        const _0x98f7c6 = function (_0x22db72, _0x4df1de) {
            let _0xfc8fb6 = [], _0x239345 = 0x0, _0x2a984f, _0x259363 = '', _0x304eb0 = '';
            _0x22db72 = atob(_0x22db72);
            for (let _0x3f45c7 = 0x0, _0x4db7a4 = _0x22db72['length']; _0x3f45c7 < _0x4db7a4; _0x3f45c7++) {
                _0x304eb0 += '%' + ('00' + _0x22db72['charCodeAt'](_0x3f45c7)['toString'](0x10))['slice'](-0x2);
            }
            _0x22db72 = decodeURIComponent(_0x304eb0);
            let _0x3a32cf;
            for (_0x3a32cf = 0x0; _0x3a32cf < 0x100; _0x3a32cf++) {
                _0xfc8fb6[_0x3a32cf] = _0x3a32cf;
            }
            for (_0x3a32cf = 0x0; _0x3a32cf < 0x100; _0x3a32cf++) {
                _0x239345 = (_0x239345 + _0xfc8fb6[_0x3a32cf] + _0x4df1de['charCodeAt'](_0x3a32cf % _0x4df1de['length'])) % 0x100;
                _0x2a984f = _0xfc8fb6[_0x3a32cf];
                _0xfc8fb6[_0x3a32cf] = _0xfc8fb6[_0x239345];
                _0xfc8fb6[_0x239345] = _0x2a984f;
            }
            _0x3a32cf = 0x0;
            _0x239345 = 0x0;
            for (let _0x47dd2d = 0x0; _0x47dd2d < _0x22db72['length']; _0x47dd2d++) {
                _0x3a32cf = (_0x3a32cf + 0x1) % 0x100;
                _0x239345 = (_0x239345 + _0xfc8fb6[_0x3a32cf]) % 0x100;
                _0x2a984f = _0xfc8fb6[_0x3a32cf];
                _0xfc8fb6[_0x3a32cf] = _0xfc8fb6[_0x239345];
                _0xfc8fb6[_0x239345] = _0x2a984f;
                _0x259363 += String['fromCharCode'](_0x22db72['charCodeAt'](_0x47dd2d) ^ _0xfc8fb6[(_0xfc8fb6[_0x3a32cf] + _0xfc8fb6[_0x239345]) % 0x100]);
            }
            return _0x259363;
        };
        a0_0x5598['LtQBMR'] = _0x98f7c6;
        a0_0x5598['ImbAOE'] = {};
        a0_0x5598['TvgkYg'] = !![];
    }
    const _0x1267db = a0_0x5598['ImbAOE'][_0x181b36];
    if (_0x1267db === undefined) {
        if (a0_0x5598['eSbKRT'] === undefined) {
            a0_0x5598['eSbKRT'] = !![];
        }
        _0x5598f0 = a0_0x5598['LtQBMR'](_0x5598f0, _0x5079ec);
        a0_0x5598['ImbAOE'][_0x181b36] = _0x5598f0;
    } else {
        _0x5598f0 = _0x1267db;
    }
    return _0x5598f0;
};
import { isDev } from '../utils/IsDev';
const env = isDev() ? a0_0x5598('0x10', 'Y8@7') : a0_0x5598('0xf', 'rhC8');
let basicToken;
if (env !== a0_0x5598('0x0', 'w!2h')) {
    basicToken = a0_0x5598('0x8', 'KXR(');
} else {
    basicToken = a0_0x5598('0x1', 'S4g9');
}
export const BASIC_TOKEN = basicToken;
let stripeKey;
if (env !== a0_0x5598('0x16', 'lCD['))
    stripeKey = a0_0x5598('0x5', 'ydiT');
else
    stripeKey = a0_0x5598('0x3', 'wu)N');
export const STRIPE_KEY = stripeKey;
export const MELISSA_ID = a0_0x5598('0x2', '5dS*');
export const OPENGRAPH_API_KEY = a0_0x5598('0xd', 'HqV4');
export const LINKEDIN_API_KEY = {
    'id': a0_0x5598('0x13', '[JtB'),
    'secret': a0_0x5598('0x14', 'McP5')
};
export const GOOGLE_GEOCODING_API_KEY = a0_0x5598('0x12', 'YBOt');
export const GOOGLE_PLACES_API_KEY = a0_0x5598('0xe', '#$Jb');
export const GOOGLE_TIMEZONE_API_KEY = a0_0x5598('0xc', 'Uw@Z');
export const FCM_SERVER_KEY = a0_0x5598('0xb', 'ydiT');
export const GCM_SENDER_ID = env !== a0_0x5598('0xa', 'LT7W') ? a0_0x5598('0x4', '7$5w') : a0_0x5598('0x11', 'ydiT');
const ANDROID_WEBCLIENT_ID = a0_0x5598('0x9', '4[BR');
const IOS_WEBCLIENT_ID = a0_0x5598('0x6', 'Fx@y');
const IOS_CLIENT_ID = a0_0x5598('0x7', 'cBT9');
export const GOOGLE_CLIENT_IDS = {
    'android_webclient_id': ANDROID_WEBCLIENT_ID,
    'ios_webclient_id': IOS_WEBCLIENT_ID,
    'ios_client_id': IOS_CLIENT_ID
};
export const GOOGLE_REACT_API_KEY = a0_0x5598('0x15', '[6&6');